import type { ReactNode } from 'react';

export interface ModelRenderFrameProps {
	/** Title shown in the frame's header bar. */
	title: string;
	/** Optional link (or other action) rendered at the header's right edge. */
	action?: ReactNode;
	/** The embedded render. */
	children: ReactNode;
}

/**
 * Compact framed container for an inline model render in markdown content: a
 * title bar with an optional action, above a fixed-height render area.
 *
 * @param props - Component props.
 */
export function ModelRenderFrame({ title, action, children }: ModelRenderFrameProps) {
	return (
		<div className='my-2 flex flex-col overflow-hidden rounded-lg border border-gray-a4'>
			<div className='flex items-center justify-between gap-2 border-b border-gray-a4 px-3 py-1.5'>
				<span className='truncate text-sm font-medium'>{title}</span>
				{action}
			</div>
			<div className='h-80 min-h-0 w-full'>{children}</div>
		</div>
	);
}
